module.exports = __webpack_public_path__ + "static/colgadas-015.thumb-f5531b210b3c6d3ca5a5e76051511491.jpg";